module.exports = __webpack_public_path__ + "img/gallery-7.c621ff34.jpg";